module.exports = __webpack_public_path__ + "static/media/ic-consultation.d3a5aca3.svg";